import styled from "styled-components";
import { color, units } from "@m/alchemy-theme";
export const CardSection = styled.div `
  color: ${color("typeBody")};
  padding: ${units(1)};
`;
